import { render, staticRenderFns } from "./LUNSimpleTable.vue?vue&type=template&id=e00f0966"
import script from "./LUNSimpleTable.vue?vue&type=script&lang=js"
export * from "./LUNSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports